import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectContactUsState = (state: RootState) => state.contactUs;

export const selectIsLoading = createSelector(
  selectContactUsState,
  (contactUsState) => contactUsState.isLoading
);
export const selectIsLoadingContacts = createSelector(
  selectContactUsState,
  (contactUsState) => contactUsState.isLoadingContacts
);
export const selectContactList = createSelector(
  selectContactUsState,
  (contactUsState) => contactUsState.contacts
);
